import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarDays, Clock, ChevronRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

const TodayAppointmentsList = ({ appointments }) => {
  const navigate = useNavigate();

  return (
    <Card className="bg-white border border-slate-200 shadow-sm">
      <CardHeader className="pb-4 border-b border-slate-100">
        <div className="flex items-center justify-between">
          <CardTitle className="font-heading text-lg font-semibold text-slate-800 flex items-center gap-2">
            <CalendarDays className="w-5 h-5 text-brand-main" strokeWidth={1.5} />
            Citas de Hoy
          </CardTitle>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={() => navigate('/agenda')}
            className="text-brand-main hover:text-brand-dark hover:bg-brand-main/5"
            data-testid="view-all-appointments"
          >
            Ver todas
            <ChevronRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
      </CardHeader>
      <CardContent className="p-0">
        {appointments.length === 0 ? (
          <div className="p-6 text-center text-slate-400">
            <CalendarDays className="w-12 h-12 mx-auto mb-3 opacity-30" />
            <p>No hay citas programadas para hoy</p>
          </div>
        ) : (
          <ul className="divide-y divide-slate-100" data-testid="today-appointments-list">
            {appointments.slice(0, 5).map((appointment) => (
              <li key={appointment.id} className="p-4 hover:bg-slate-50 transition-colors">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-xl bg-brand-main/5 flex items-center justify-center flex-shrink-0">
                    <Clock className="w-5 h-5 text-brand-main" strokeWidth={1.5} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-1">
                      <p className="font-medium text-slate-800 truncate">
                        {appointment.patient_name}
                      </p>
                      <Badge 
                        variant="secondary" 
                        className="bg-brand-cyan/10 text-brand-cyan border-0 font-medium"
                      >
                        {appointment.hora_inicio || appointment.time}
                      </Badge>
                    </div>
                    <p className="text-sm text-slate-500">{appointment.tipo_examen}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
};

export default TodayAppointmentsList;
